import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  container: {
    position: 'relative !important' as 'relative',
    zIndex: '10 !important',
    minHeight: '300 !important',
    overflow: 'visible !important',
  },
  commentsWrapper: {
    padding: theme.spacing(8),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(4),
    },
  },
}))
